import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=7bf86086&scoped=true"
import script from "./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue?vue&type=script&lang=js"
import style0 from "./Chatroom.vue?vue&type=style&index=0&id=7bf86086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf86086",
  null
  
)

export default component.exports